import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import storage from 'core/localStorage';
import { analytics } from 'core/analytics';

import { modalStore } from 'apps/modals/app';

import Icon from 'components/Icon';
import Heading from 'components/Heading';
import Button from 'components/Button';
import InputFile from 'components/InputFile';
import BrandsList from 'apps/home/workspace/blocks/brandList';
import SampleBanner from 'apps/share/blocks/SampleBanner';
import FileFormatsTableModal from 'apps/modals/fileFormatsTable';
import GltfLoading from 'libs/rendering/gltf/components/loading/loading';

import {
  InputFileWrapper,
  RowWrapper,
  IconWrapper,
  ColumnWrapper,
  ActiveEventsWrapper,
  FooterWrapper,
} from 'apps/share/blocks/ShareInputFile.styles';

const SAMPLE_BANNER_KEY = 'shareFileSampleBanner';

const ShareInputFile = withNamespaces()(
  inject('clientStore')(
    observer(props => {
      const { clientStore, sharedFileManager } = props;

      const initSampleBannerOpen = () => {
        if (storage.get(SAMPLE_BANNER_KEY) === null) {
          storage.set(SAMPLE_BANNER_KEY, { show: true }, true);
        }

        return !!storage.get(SAMPLE_BANNER_KEY)?.show;
      };

      const [isSampleBannerOpen, setIsSampleBannerOpen] = useState(
        initSampleBannerOpen(),
      );

      const onCloseSampleBanner = () => {
        storage.set(SAMPLE_BANNER_KEY, { show: false }, true);
        setIsSampleBannerOpen(false);
      };

      if (sharedFileManager.hasDroppedFile) {
        const {
          clientStore: { uploader },
        } = props;
        return (
          <GltfLoading
            text={uploader.uploadsQueue[0]?.uploadStatusTextLong}
            visible
          />
        );
      }

      const { form, HandleFileDrop } = sharedFileManager;

      const fieldStore = form.fieldStores.get('sharedFile');
      const { Dragging, StopDragging } = fieldStore;

      const openFileFormatsModal = () => {
        modalStore.SetModalComponent(FileFormatsTableModal, { size: 'large' });
      };

      // FIXME - connect to space selector once that's available
      const sharedFileSpace = clientStore?.signedInProfile?.inSpace;
      const cubeIconStyle = clientStore.isMobile
        ? { width: 70, height: 70 }
        : { width: 100, height: 100 };

      return (
        <InputFileWrapper isSampleBannerOpen={isSampleBannerOpen}>
          <InputFile
            shareFile
            accept={fieldStore.conf.accept}
            setOnChange={e => {
              // HubSpot?
              analytics.sendEvent('share-file-upload-file', {}, { ga: true });
              HandleFileDrop(e);
            }}
            setOnDragEnter={Dragging}
            setOnDragLeave={StopDragging}
            disabled={
              sharedFileSpace &&
              !sharedFileSpace.hasProSubscription &&
              sharedFileSpace.remainingSharedFiles === 0
            }
          >
            <RowWrapper isSampleBannerOpen={isSampleBannerOpen}>
              <IconWrapper>
                <Icon name='cube' style={cubeIconStyle} />
              </IconWrapper>
              <ColumnWrapper>
                <Heading level={1} size='xlarge' margin='small 0 0 0'>
                  <Trans>Upload any* CAD file.</Trans>
                </Heading>
                <Heading
                  level={6}
                  weight='regular'
                  size='medium'
                  margin='large 0'
                >
                  <Trans>Drag your file here or...</Trans>
                </Heading>
                <Button
                  outline
                  size='small'
                  variant='tertiary'
                  text={<Trans>Browse...</Trans>}
                />
              </ColumnWrapper>
            </RowWrapper>
            {isSampleBannerOpen && (
              <ActiveEventsWrapper>
                <SampleBanner onClose={onCloseSampleBanner} />
              </ActiveEventsWrapper>
            )}
            <FooterWrapper>
              <BrandsList size='small' />
              <ActiveEventsWrapper>
                <Button
                  text={<Trans>* View all supported formats</Trans>}
                  appearance='plain'
                  icon='arrow_right'
                  iconPosition='right'
                  variant='secondary'
                  onClick={openFileFormatsModal}
                />
              </ActiveEventsWrapper>
            </FooterWrapper>
          </InputFile>
        </InputFileWrapper>
      );
    }),
  ),
);

ShareInputFile.propTypes = {
  clientStore: PropTypes.object,
  sharedFileManager: PropTypes.object,
};

export default ShareInputFile;
